import { getDefaultConversation } from '@strata/react-chat';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { setUserSupportConversation } from 'services/userSupportHelpers';
import { updateCurrentConversation } from 'store/userSupport/userSupportSlice';

export const useRedirectedConversation = (conversations) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { userSupportRestFetch } = useFlags();
    const selectedConversationId = useSelector((state) => state.userSupport.currentConversation);
    const currentReferral = useSelector((state) => state.userSupport.currentReferral);

    useEffect(() => {
        const { defaultConversation } = conversations
            ? getDefaultConversation(conversations, true)
            : {};

        const { conversationId } = location.state ?? {};

        const redirectedConversation = conversationId ?? defaultConversation?.conversationId;

        if (!selectedConversationId && redirectedConversation) {
            dispatch(updateCurrentConversation({ conversationId: redirectedConversation }));
        }
    }, [conversations, dispatch, location, selectedConversationId]);

    // Will unset the subscribed conversation on unmount
    useEffect(
        () => () => {
            // With REST fetch on there is no socket subscription to clear.
            if (!userSupportRestFetch) {
                dispatch(setUserSupportConversation(null));
            }
            dispatch(updateCurrentConversation());
        },
        [dispatch, currentReferral, userSupportRestFetch],
    );
};
